import { defineStore } from 'pinia'
import { getIndustries } from '@/api/shared/industries'
import type { Industry } from '@/types/industry'

interface IndustryState {
  industries: Industry[]
  isLoading: boolean
  error: string | null
}

export const useIndustryStore = defineStore('industry', {
  state: (): IndustryState => ({
    industries: [],
    isLoading: false,
    error: null,
  }),

 actions: {
  async fetchIndustries(force = false) {
    if (this.industries.length && !force) return // ✅ cached
    this.isLoading = true
    this.error = null
    try {
      const response = await getIndustries()
      // ✅ FIX: unwrap the "data" field inside response.data
      this.industries = response.data.data
    } catch (err: any) {
      console.error('Failed to fetch industries:', err)
      this.error = err.response?.data?.error || 'Failed to fetch industries'
    } finally {
      this.isLoading = false
    }
  },
},
})
